<template>
  <div class="pl-4">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <b-row>
      <b-col cols="8">
        <div class="import-section">
          <input
            type="file"
            accept=".json"
            @change="onFileChange"
          >
          <v-btn
            :loading="isLoadingImportFile"
            flat
            :disabled="!selectedFile"
            @click="importFile"
          >
            <i class="fas fa-upload mr-2" /> Feiertagsregionen Importieren
          </v-btn>
        </div>
      </b-col>
      <b-col>
        <div class="export-section">
          <v-btn
            :loading="isLoadingImportFile"
            flat
            @click="exportFile"
          >
            <i class="fas fa-download mr-2" /> Feiertagsregionen Exportieren
          </v-btn>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ImportPublicHolidayRegions,
  ExportPublicHolidayRegions,
} from "@/services/minimum.wage.services/publicholidayRegions.minimum.wage";

export default {
  data() {
    return {
      errorObject: null,
      selectedFile: null,
      isLoadingImportFile: false,
    };
  },
  methods: {
    onFileChange(event) {
      const target = event.target;
      this.selectedFile = (target && target.files && target.files[0]) ? target.files[0] : null;
    },
    async importFile() {
      if (!this.selectedFile) return;

      this.isLoadingImportFile = true;
      const file = this.selectedFile

      //Get the JSON from the file
      const reader = new FileReader();

      reader.onload = () => {
        var jsonObject = null;
        try {
          jsonObject = JSON.parse(reader.result);
        } catch (error) {
          this.errorObject = "Fehler beim einlesen der Datei. Bitte überprüfen sie, dass es sich um eine gültige JSON-Datei handelt.";
          this.isLoadingImportFile = false;
        }

        try {
          if (jsonObject) {
            ImportPublicHolidayRegions(
              jsonObject,
              (respond) => {
                if (respond) {
                  this.$emit("imported", respond);
                }
                this.isLoadingImportFile = false;
              },
              (error) => {
                this.errorObject = error;
                this.isLoadingImportFile = false;
              },
            );
          }
        } catch (error) {
          this.errorObject = error;
          this.isLoadingImportFile = false;
        }
      };

      reader.onerror = (error) => {
        this.errorObject = error;
        this.isLoadingImportFile = false;
      };

      reader.readAsText(file);
    },
    exportFile() {
      const onSucess = (response) => {
        if (response) {
          //Export response as JSON File
          const data = response;
          const json = JSON.stringify(data);
          const blob = new Blob([json], {
            type: "application/json",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");

          //Filename
          a.download =
            new Date().toISOString().replace(/[-T:]/g, "").split(".")[0] +
            "_Feiertagsregionen.json";

          a.href = url;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      };

      const onError = (error) => {
        console.error(error);
      };

      ExportPublicHolidayRegions(onSucess, onError);
    },
  },
};
</script>
